import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceCustomerDetailsRoute: InvariantJiraRoute = {
	name: 'customer-service-customer-details',
	path: '/jira/customer-service/customers/:customerId',
	exact: true,
};
